import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  margin-top: 24px;
  gap: 24px;
  margin-top: 16px;
`;

export const ButtonContainer = styled.div`
  flex-shrink: 0;
`;

export const Subtitle = styled.div`
  margin-top: 8px;
  max-width: 600px;
`; 